// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"817":"117546c9","5447":"af1b631c"}[chunkId] + ".chunk.css";
};